<template>
  <div>
    <ValidationObserver ref="formSignatures">
      <div class="ml-3">
        <div class="row">
          <div class="col-5 pr-0">
            <div class="border-bottom add-comment-label">
              ¿Quieres añadir algún comentario sobre el proceso de transición?
            </div>
          </div>
          <div class="col px-0 ">
            <validation-provider v-slot="{ errors }" rules="required">
              <custom-radio
                is-question-list
                id="hasComment"
                name="hasComment"
                class="radio-button-container pb-3"
                custom-error-msg="Favor de seleccionar Si o No."
                v-model="model.hasComment"
                :key="model.hasComment"
                :options="commentOptions"
                :change-event="onChangeHasComment"
                :disabled="isReadOnly"
                :error="Boolean(errors[0])"
              />
            </validation-provider>
          </div>
          <div v-if="model.hasComment" class="col-12">
            <validation-provider
              v-slot="{ errors }"
              name="comment"
              rules="required"
            >
              <custom-text-area
                id="comment"
                label="Comentario:"
                placeholder="Escribe un comentario"
                v-model="model.comment"
                :maxlength="500"
                :disabled="isReadOnly"
                :error="errors[0]"
                custom-error-msg="Favor registrar comentario."
              />
            </validation-provider>
          </div>
        </div>
      </div>

      <section-title
        icon="fas fa-file-user"
        container-class="tag-badge-main-info mt-2 mb-2"
        content="Firmas"
      />

      <div class="col-12">
        <div
          v-if="isReadOnly"
          class="participant-signatures bg-secondary-3 border-radius--light"
        >
          <div
            v-for="(item, index) in data.signatures"
            class="participant"
            :key="index"
          >
            <participant-signature-row :item="item" />
          </div>
        </div>
        <participant-signatures
          v-else-if="data.availableSignatureOptions.length > 0"
          ref="ParticipantSignatures"
          :key="lastId"
          is-draft
          :value.sync="model.signatureList"
          :options="data.availableSignatureOptions"
          :participation-types="data.participationTypeList"
          :alternate-participations="data.alternateParticipationTypeList"
          :info-message="data.signatureInfoMessage"
          @addSignature="handleAddSignature"
          @deleteSignature="handleDeleteSignature"
          @update:participationTypes="() => lastId++"
        />
        <div class="mt-5">
          <div class="mt-3 tag-badge pl-2">
            <span class="dot text-center">
              <i
                class="far fa-check-circle orange-icon orange-icon-badge-align"
              ></i>
            </span>
            <span class="tag-badge-title py-1 pl-2">
              Certificación de procedimientos
            </span>
          </div>
        </div>
        <custom-checkbox-single-option
          v-model="model.termsAccepted"
          :disabled="isReadOnly"
          title="Certifico por este medio, que este referido podrá encontrarse en el expediente físico del estudiante firmado por todas las partes involucradas. (0502)"
          option-text="Acepto"
        />
      </div>
    </ValidationObserver>
    <div class="py-4 d-flex justify-content-end">
      <action-button
        type="button"
        text="Continuar"
        i="fas fa-arrow-alt-circle-right"
        variant="success"
        @click="next"
      />
    </div>
  </div>
</template>

<script>
import ActionButton from "ActionButton";
import SectionTitle from "SectionTitle";
import ParticipantSignatures from "@/components/pei/tabs/components/Tab9/participantSignatures/Tab9ParticipantSignatures";
import ParticipantSignatureRow from "./ParticipantSignatureRow";
import CustomCheckboxSingleOption from "custom-checkbox-single-option";
import CustomRadio from "@/components/common/CustomRadioBorder";
import CustomTextArea from "CustomTextArea";
export default {
  name: "Signatures",
  components: {
    ActionButton,
    SectionTitle,
    ParticipantSignatures,
    ParticipantSignatureRow,
    CustomCheckboxSingleOption,
    CustomRadio,
    CustomTextArea
  },
  props: {
    data: {
      type: Object,
      dafault: () => ({})
    },
    value: {
      type: Object,
      dafault: () => ({})
    },
    isReadOnly: {
      type: Boolean,
      dafault: () => false
    }
  },
  data: () => ({
    commentOptions: [],
    lastId: 0
  }),
  mounted() {
    this.commentOptions = [
      { label: "SI", value: true, check: Boolean(this.value.hasComment) },
      { label: "NO", value: false, check: !Boolean(this.value.hasComment) }
    ];
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  },
  methods: {
    async validate() {
      let valid = true;
      const fails = [];
      const ul = document.createElement("ul");
      const { termsAccepted, hasComment, comment } = this.model;
      if (!termsAccepted) {
        valid = false;
        fails.push("La certificación es requerida");
      }
      if (hasComment && !Boolean(comment)) {
        valid = false;
        fails.push("El Comentario es requerido");
      }
      const signatureFormValid = await this.$refs.ParticipantSignatures.$refs.observer.validate();
      this.$refs.ParticipantSignatures.$forceUpdate();
      this.model.signatureList.forEach(x => (x.isRequired = true));
      const { getGroupName } = this.$refs.ParticipantSignatures;
      const invalidSignatureRequired = this.model.signatureList
        ?.filter(({ groupId }) => [1, 5, 4].includes(groupId))
        .map(item => {
          const valid =
            Boolean(item.signature?.name) &&
            Boolean(item.signature?.participationId) &&
            Boolean(item.signature?.positionId);
          return !valid ? getGroupName(item) : "";
        });
      const signaturesInvalid = invalidSignatureRequired?.some(x => Boolean(x));
      if (signaturesInvalid && !signatureFormValid) {
        valid = false;
        fails.push(`Todas las firmas son requeridas`);
      }

      fails.forEach(m => {
        const li = document.createElement("li");
        li.textContent = m;
        ul.appendChild(li);
      });
      return { valid, message: ul.innerHTML };
    },
    next() {
      this.$emit("next", this.value);
    },
    onChangeHasComment({ value }) {
      this.model.hasComment = value;
      this.model.comment = value ? this.data.comment : null;
      this.$emit("input", this.model);
      this.$forceUpdate();
    },
    handleAddSignature() {
      this.lastId =
        this.model.signatureList[this.model.signatureList.length - 1].id + 1;
      const item = {
        id: this.lastId,
        signature: {
          name: "",
          positionId: undefined,
          participationId: undefined,
          alternateId: undefined
        },
        groupId: 0,
        isRequired: false,
        isRemovable: true,
        isDraft: true,
        isDisabled: false
      };
      this.model.signatureList.push(item);
      this.$forceUpdate();
    },
    handleDeleteSignature(id) {
      this.model.signatureList = this.model.signatureList.filter(
        signature => signature.id !== id
      );
      this.$forceUpdate();
    }
  }
};
</script>
<style scoped lang="scss">
.tag-badge {
  display: inline-block;
  padding-right: 1em;
  height: 42px;
  background: transparent linear-gradient(90deg, #ffffff 0%, #e8e8e8 100%) 0% 0%
    no-repeat padding-box;
  border-radius: 26px;
  cursor: pointer;
  margin-bottom: 10px;
}

.dot {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  display: inline-block;
  /* top: 268px; */
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  padding-top: 9px;
}
.orange-icon {
  color: #ff7058;
}

.orange-icon-badge-align {
  vertical-align: top;
}

.tag-badge-title {
  text-align: left;
  font: Bold 25px/30px Lato;
  letter-spacing: 0;
  color: #11291b;
  display: inline-block;
}

.border-box {
  border: 1px solid #e2e2e2;
  border-radius: 5px 5px 0px 0px;
  padding: 20px;
  width: 100%;
}
.border-box.gray {
  border-radius: 0px 0px 5px 0px;
  background: #f2f2f2 0% 0% no-repeat padding-box;
  border-top: none;
  padding: 20px 0;
}
.border-box.gray.error {
  background: #ffebeb 0% 0% no-repeat padding-box;
  border: 1px solid #c9545e;
}
.invalid {
  text-align: left;
  font: Lato, Regular;
  letter-spacing: 0;
  color: #ff5b5c;
  margin-bottom: 5px;
  font-weight: normal;
}
i.far.fa-check-circle {
  font-size: 24px;
  padding-right: 4px;
  line-height: 18px;
  margin-left: 4px;
}
.custom-control {
  margin-left: 20px; /* This moves the checkbox to the right */
}
.signed {
  background-color: #2db782;
  color: white;
}
.unsigned {
  background-color: #f7f7f7;
  color: black;
}
::v-deep .checkbox-word-container p,
::v-deep .title-container p {
  font-weight: bold !important;
}
.text-danger ::v-deep .tag-badge-title-info {
  color: #c9545e !important;
}
.participant-signatures {
  .participant {
    padding: 1rem;
  }
}
.add-comment-label {
  color: #727272;
  padding: 14px 0px;
}
::v-deep .radio-button-container .bg-green {
  background: #2db782 !important;
}
</style>
